// Ghi .gitignore: tạo mới nếu chưa có, merge content nếu đã có. Merge logic
// dùng marker `# === avatar === ... # === /avatar ===`: replace block đó nếu
// tồn tại, append nếu chưa.
import { existsSync, readFileSync, writeFileSync } from "node:fs";
import { join } from "node:path";
import { AVATAR_MARKER_END, AVATAR_MARKER_START } from "./gitignore-template-loader.js";

export function writeOrMergeGitignore(folderPath: string, avatarBlock: string): void {
  const path = join(folderPath, ".gitignore");

  if (!existsSync(path)) {
    writeFileSync(path, avatarBlock, "utf8");
    return;
  }

  const existing = readFileSync(path, "utf8");
  const startIdx = existing.indexOf(AVATAR_MARKER_START);
  const endIdx = existing.indexOf(AVATAR_MARKER_END);

  // Đã có marker → replace block giữa marker (giữ content trước/sau).
  if (startIdx !== -1 && endIdx !== -1 && endIdx > startIdx) {
    const before = existing.slice(0, startIdx);
    const after = existing.slice(endIdx + AVATAR_MARKER_END.length);
    writeFileSync(path, `${before.trimEnd()}\n\n${avatarBlock}${after.trimStart()}`, "utf8");
    return;
  }

  // Chưa có marker → append phía cuối, thêm newline phân cách.
  writeFileSync(path, `${existing.trimEnd()}\n\n${avatarBlock}`, "utf8");
}
